<template>
  <!-- 予約編集/追加 -->
  <div id="AppAppointmentEdit" :status="status">
    <appointment-edit ref="editContents" />
    <!-- 余白 -->
    <div style="height: 50px;" />
    <!-- 戻るボタン -->
    <div style="text-align:center;">
      <b-button
        v-on:click="back"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
      >戻る</b-button>
      <b-button
        v-if="status <='4'&& !editFlg"
        v-on:click="regist"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >登録</b-button>
      <b-button
        v-if="(isCrossBorder && status=='1'&& !editFlg) || (!isCrossBorder && status=='2'&& !editFlg) || (roleId!=2 && status!=5 && status !=6)"
        v-on:click="doWithdrawale"
        class="button"
        type="is-primary"
        icon-left="select-off"
        native-type="button"
      >{{ cancelButtonName }}</b-button>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import AppointmentEditTemplate from "./AppAppointmentEditContents";
export default {
  name: "AppAppointmentEdit",
  computed: {
    cancelButtonName: function () {
      const name = this.$route.params.isDealer ? "削除" : "取り消し"
      return name;
    },
  },
  methods: {
    back: function(event) {
      this.doReturn();
    },
    regist: async function(event) {
      var editContents = this.$refs.editContents;
      var validatorResult = await editContents.check(false);
      if (validatorResult) {
        editContents.save().then(result => {
          if (editContents.isSuccessEnd()) {
            this.doReturn();
          }
        });
      } else {
        scrollTo(0, 0);
      }
    },
    doWithdrawale: async function(event) {
      const cancelButtonName = this.cancelButtonName;
      const comfirmCancel = await this.showComfirmMessage(cancelButtonName + "を行うと、元に戻すことはできません。\n" + cancelButtonName + "を行いますか？");
      if (!comfirmCancel) {
        return;
      }

      var editContents = this.$refs.editContents;
      var validatorResult = await editContents.check(true);
      if (validatorResult) {
        editContents.cancel().then(result => {
          if (editContents.isSuccessEnd()) {
            this.doReturn();
          }
        });
      } else {
        scrollTo(0, 0);
      }
    },
    doReturn: function(event) {
      if (this.$route.params["status"] === "4") {
        this.$router.push({
          name: "AppInspectionSearch",
          params: { searchConditions: this.searchConditions }
        });
      } else {
        this.$router.push({
          name: "AppAppointmentSearch",
          params: { searchConditions: this.searchConditions }
        });
      }
    }
  },
  data() {
    var status = this.$route.params["status"];
    var editFlg = this.$route.params["editFlg"];
    var isCrossBorder = this.$route.params["isCrossBorder"];
    var appointmentCode = this.$route.params["appointmentCode"];
    var searchConditions = this.$route.params["searchConditions"];
    var roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
    return {
      status,
      isCrossBorder,
      appointmentCode,
      searchConditions,
      roleId,
      editFlg
    };
  },
  components: {
    "appointment-edit": AppointmentEditTemplate
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppAppointmentEdit.vue